import React from "react";
import {FormItemProps, FormItem} from './FormItem'
import {IField, getRequiredError} from './FieldValidation'
import {ErrorText} from './ErrorText';
import ReactTooltip from 'react-tooltip';

export interface CheckboxProps extends FormItemProps {
    id: string
    required?: boolean
    requiredMessage?: string
    onChange: { (value: boolean): any }
    value: boolean
    disabled?: boolean
    validateError?: boolean
}

export interface CheckboxState {
    errorText?: string
}

export class Checkbox extends React.Component<CheckboxProps, CheckboxState> implements IField {
    input: HTMLInputElement

    constructor(props?: CheckboxProps, context?: any) {
        super(props, context);

        this.state = {
        };
    }

    componentDidUpdate(prevProps: CheckboxProps, prevState: CheckboxState) {
        if (this.props.value != prevProps.value) {
            if (this.state.errorText) {
                this.validate(() => { });
            }
        }
    }

    render() {
        if (this.props.preview) {
            return (
                <>
            <FormItem {...this.props} errorMessage={this.state.errorText}>
                <div className="form-value">{this.props.value != null ? this.props.value == true ? "Yes" : "No" : "--" }</div>
            </FormItem>
            {this.props.description && (
            <FormItem label={<span className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
                {this.props.description}
            </span>}>
            </FormItem>
            )}
            </>
            )
        }

        return <>
            <div className={
                `emdg-control-input emdg-control-input--block` +
                `${this.state.errorText || this.props.validateError ? ' emdg-control-input--invalid' : ''}` +
                `${this.props.className ? (' ' + this.props.className) : ''}`
            }>
                <input ref={r => this.input = r}
                    className="emdg-control-input__input"
                    id={this.props.id}
                    type="checkbox"
                    checked={this.props.value || false}
                    onChange={e => this.props.onChange(e.currentTarget.checked)}
                    disabled={this.props.disabled}/>
                <label className="emdg-control-input__text mb-0" htmlFor={this.props.id}>{this.props.required ? <span>* {this.props.label}</span> : this.props.label} {this.props.help ? <a className="far fa-question-circle" data-for={`${this.props.id}-help`} data-tip onClick={e => { e.stopPropagation(); e.preventDefault(); }}></a> : <></>}</label>
                {this.props.description && <div>{this.props.description}</div>}
                <ErrorText text={this.state.errorText} />
            </div>
            {this.props.help ? <ReactTooltip className='aus-tooltip' delayHide={500} effect='solid' getContent={tip => this.props.help} id={`${this.props.id}-help`} globalEventOff='click' /> : <></>}
        </>
    }

    getValue(): boolean {
        return this.props.value;
    }

    focus() {
        this.input.focus();
    }

    getErrorText(): string {
        let val = this.getValue();
        if (this.props.required === true) {
            if (!this.getValue()) {
                return getRequiredError(this.props);
            }
        }
        return null;
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        let errorTest = this.getErrorText();
        this.setError(errorTest, () => {
            if (errorTest) {
                if (focus === true) {
                    this.focus();
                }
            }
            callback && callback(errorTest ? false : true);
        })
    }

    setError(errorText?: string, callback?: { (): any }) {
        this.setState({
            errorText: errorText
        }, callback);
    }
}